import {
  required,
  Create,
  SimpleForm,
  FileInput,
  FileField,
  SelectInput,
  ReferenceInput,
  BooleanInput,
} from "react-admin";
import { CustomToolbar } from "../../../utils";

const validateRequired = required();

const SectorCreate = (props) => (
  <Create title="Novo Setor" {...props}>
    <SimpleForm redirect="false" toolbar={<CustomToolbar />}>
      <ReferenceInput
        sort={{ field: "name", order: "ASC" }}
        perPage={999}
        resource="lab"
        source="lab"
        reference="labs"
        validate={validateRequired}
      >
        <SelectInput
          optionText="name"
          label="Laboratório"
          optionValue="id"
          validate={validateRequired}
        />
      </ReferenceInput>
      <BooleanInput label="Gerente Distrital" source="isGD" />

      <div>
        <FileInput
          source="csv"
          label="Lista de dados do setor"
          accept=".csv"
          validate={validateRequired}
        >
          <FileField source="src" title="title" />
        </FileInput>
      </div>
    </SimpleForm>
  </Create>
);
export default SectorCreate;
